/** Smaller body copy for document TipTap editors (BOL boilerplate). Must match PDF sanitizer whitelist in rich-text.ts. */
export const DOCUMENT_EDITOR_FONT_SIZE_SMALL = "0.65rem";

export const PDF_SAFE_DOCUMENT_FONT_SIZES = new Set<string>([DOCUMENT_EDITOR_FONT_SIZE_SMALL]);

export const DOCUMENT_EDITOR_FONT_SIZE_OPTIONS = [
  { value: "", label: "Normal size" },
  { value: DOCUMENT_EDITOR_FONT_SIZE_SMALL, label: "Small" },
] as const;
